// featured
import featuredProject1 from '../images/projects/featured/1.webp'
import featuredProject2 from '../images/projects/featured/2.webp'
import featuredProject3 from '../images/projects/featured/3.webp'
import featuredProject4 from '../images/projects/featured/4.webp'
// all
import project1 from '../images/projects/1.png'
import projectThumbnail1 from '../images/projects/1-sm.jpg'
import project2 from '../images/projects/2.png'
import projectThumbnail2 from '../images/projects/2-sm.jpg'
import project3 from '../images/projects/3.png'
import projectThumbnail3 from '../images/projects/3-sm.jpg'
import project4 from '../images/projects/4.png'
import projectThumbnail4 from '../images/projects/4-sm.jpg'
import project5 from '../images/projects/5.png'
import projectThumbnail5 from '../images/projects/5-sm.jpg'
import project6 from '../images/projects/6.png'
import projectThumbnail6 from '../images/projects/6-sm.jpg'
import project7 from '../images/projects/7.png'
import projectThumbnail7 from '../images/projects/7-sm.jpg'
import project8 from '../images/projects/8.png'
import projectThumbnail8 from '../images/projects/8-sm.jpg'
import project9 from '../images/projects/9.png'
import projectThumbnail9 from '../images/projects/9-sm.jpg'
import project10 from '../images/projects/10.png'
import projectThumbnail10 from '../images/projects/10-sm.jpg'
import project11 from '../images/projects/11.png'
import projectThumbnail11 from '../images/projects/11-sm.jpg'
import project12 from '../images/projects/12.png'
import projectThumbnail12 from '../images/projects/12-sm.jpg'

// logo design
import logo1 from '../images/projects/logo-design/1.jpg'
import logo2 from '../images/projects/logo-design/2.jpg'
import logo3 from '../images/projects/logo-design/3.jpg'
import logo4 from '../images/projects/logo-design/4.gif'
import logo5 from '../images/projects/logo-design/5.jpg'
import logo6 from '../images/projects/logo-design/6.jpg'
import logo7 from '../images/projects/logo-design/7.jpg'
import logo8 from '../images/projects/logo-design/8.jpg'
import logo9 from '../images/projects/logo-design/9.gif'
import logo10 from '../images/projects/logo-design/10.jpg'
import logo11 from '../images/projects/logo-design/11.jpg'
import logo12 from '../images/projects/logo-design/12.jpg'

// mobile application
import mobileApp1 from '../images/projects/mobile-application/1.jpg'
import mobileApp2 from '../images/projects/mobile-application/2.png'
import mobileApp3 from '../images/projects/mobile-application/3.png'
import mobileApp4 from '../images/projects/mobile-application/4.png'
import mobileApp5 from '../images/projects/mobile-application/5.png'
import mobileApp6 from '../images/projects/mobile-application/6.jpg'
import mobileApp7 from '../images/projects/mobile-application/7.png'
import mobileApp8 from '../images/projects/mobile-application/8.png'
import mobileApp9 from '../images/projects/mobile-application/9.jpg'
import mobileApp10 from '../images/projects/mobile-application/10.jpg'

import ecommerce1 from '../images/projects/ecommerce/1.png'
import ecommerceFull1 from '../images/projects/ecommerce/1-full.png'
import ecommerce2 from '../images/projects/ecommerce/2.png'
import ecommerceFull2 from '../images/projects/ecommerce/2-full.png'
import ecommerce3 from '../images/projects/ecommerce/3.png'
import ecommerceFull3 from '../images/projects/ecommerce/3-full.png'
import ecommerce4 from '../images/projects/ecommerce/4.png'
import ecommerceFull4 from '../images/projects/ecommerce/4-full.png'
import ecommerce5 from '../images/projects/ecommerce/5.png'
import ecommerceFull5 from '../images/projects/ecommerce/5-full.png'
import ecommerce6 from '../images/projects/ecommerce/6.png'
import ecommerceFull6 from '../images/projects/ecommerce/6-full.png'

// shopify
import shopify1 from '../images/projects/shopify/1.png'
import shopifyFull1 from '../images/projects/shopify/1-full.png'
import shopify2 from '../images/projects/shopify/2.png'
import shopifyFull2 from '../images/projects/shopify/2-full.png'
import shopify3 from '../images/projects/shopify/3.png'
import shopifyFull3 from '../images/projects/shopify/3-full.png'
import shopify4 from '../images/projects/shopify/4.png'
import shopifyFull4 from '../images/projects/shopify/4-full.png'
import shopify5 from '../images/projects/shopify/5.png'
import shopifyFull5 from '../images/projects/shopify/5-full.png'
import shopify6 from '../images/projects/shopify/6.png'
import shopifyFull6 from '../images/projects/shopify/6-full.png'
import shopify7 from '../images/projects/shopify/7.png'
import shopifyFull7 from '../images/projects/shopify/7-full.png'
import shopify8 from '../images/projects/shopify/8.png'
import shopifyFull8 from '../images/projects/shopify/8-full.png'
import shopify9 from '../images/projects/shopify/9.png'
import shopifyFull9 from '../images/projects/shopify/9-full.png'

// wordpress
import wordpress1 from '../images/projects/wordpress/1.png'
import wordpressFull1 from '../images/projects/wordpress/1-full.png'
import wordpress2 from '../images/projects/wordpress/2.png'
import wordpressFull2 from '../images/projects/wordpress/2-full.png'
import wordpress3 from '../images/projects/wordpress/3.png'
import wordpressFull3 from '../images/projects/wordpress/3-full.png'
import wordpress4 from '../images/projects/wordpress/4.png'
import wordpressFull4 from '../images/projects/wordpress/4-full.png'
import wordpress5 from '../images/projects/wordpress/5.png'
import wordpressFull5 from '../images/projects/wordpress/5-full.png'
import wordpress6 from '../images/projects/wordpress/6.webp'
import wordpressFull6 from '../images/projects/wordpress/6-full.png'
import wordpress7 from '../images/projects/wordpress/7.webp'
import wordpressFull7 from '../images/projects/wordpress/7-full.png'
import wordpress8 from '../images/projects/wordpress/8.webp'
import wordpressFull8 from '../images/projects/wordpress/8-full.png'
import wordpress9 from '../images/projects/wordpress/9.webp'
import wordpressFull9 from '../images/projects/wordpress/9-full.png'
import wordpress10 from '../images/projects/wordpress/10.webp'
import wordpressFull10 from '../images/projects/wordpress/10-full.png'
import wordpress11 from '../images/projects/wordpress/11.webp'
import wordpressFull11 from '../images/projects/wordpress/11-full.png'
import wordpress12 from '../images/projects/wordpress/12.webp'
import wordpressFull12 from '../images/projects/wordpress/12-full.png'

export const featuredProjects = [
    {
        thumbnail: featuredProject1,
        fullImage: featuredProject1
    },
    {
        thumbnail: featuredProject2,
        fullImage: featuredProject2
    },
    {
        thumbnail: featuredProject3,
        fullImage: featuredProject3
    },
    {
        thumbnail: featuredProject4,
        fullImage: featuredProject4
    }
]
export const projects = [
    {
        title: '',
        thumbnail: projectThumbnail1,
        fullImage: project1
    },
    {
        title: '',
        thumbnail: projectThumbnail2,
        fullImage: project2
    },
    {
        title: '',
        thumbnail: projectThumbnail3,
        fullImage: project3
    },
    {
        title: '',
        thumbnail: projectThumbnail4,
        fullImage: project4
    },
    {
        title: '',
        thumbnail: projectThumbnail5,
        fullImage: project5
    },
    {
        title: '',
        thumbnail: projectThumbnail6,
        fullImage: project6
    },
    {
        title: '',
        thumbnail: projectThumbnail7,
        fullImage: project7
    },
    {
        title: '',
        thumbnail: projectThumbnail8,
        fullImage: project8
    },
    {
        title: '',
        thumbnail: projectThumbnail9,
        fullImage: project9
    },
    {
        title: '',
        thumbnail: projectThumbnail10,
        fullImage: project10
    },
    {
        title: '',
        thumbnail: projectThumbnail11,
        fullImage: project11
    },
    {
        title: '',
        thumbnail: projectThumbnail12,
        fullImage: project12
    }
]
export const logoDesignProjects = [
    {
        title: '',
        thumbnail: logo1,
        fullImage: logo1
    },
    {
        title: '',
        thumbnail: logo2,
        fullImage: logo2
    },
    {
        title: '',
        thumbnail: logo3,
        fullImage: logo3
    },
    {
        title: '',
        thumbnail: logo4,
        fullImage: logo4
    },
    {
        title: '',
        thumbnail: logo5,
        fullImage: logo5
    },
    {
        title: '',
        thumbnail: logo6,
        fullImage: logo6
    },
    {
        title: '',
        thumbnail: logo7,
        fullImage: logo7
    },
    {
        title: '',
        thumbnail: logo8,
        fullImage: logo8
    },
    {
        title: '',
        thumbnail: logo9,
        fullImage: logo9
    },
    {
        title: '',
        thumbnail: logo9,
        fullImage: logo9
    },
    {
        title: '',
        thumbnail: logo10,
        fullImage: logo10
    },
    {
        title: '',
        thumbnail: logo11,
        fullImage: logo11
    },
    {
        title: '',
        thumbnail: logo12,
        fullImage: logo12
    }
]
export const mobileApplicationProjects = [
    {
        title: '',
        thumbnail: mobileApp1,
        fullImage: mobileApp1
    },
    {
        title: '',
        thumbnail: mobileApp2,
        fullImage: mobileApp2
    },
    {
        title: '',
        thumbnail: mobileApp3,
        fullImage: mobileApp3
    },
    {
        title: '',
        thumbnail: mobileApp4,
        fullImage: mobileApp4
    },
    {
        title: '',
        thumbnail: mobileApp5,
        fullImage: mobileApp5
    },
    {
        title: '',
        thumbnail: mobileApp6,
        fullImage: mobileApp6
    },
    {
        title: '',
        thumbnail: mobileApp7,
        fullImage: mobileApp7
    },
    {
        title: '',
        thumbnail: mobileApp8,
        fullImage: mobileApp8
    },
    {
        title: '',
        thumbnail: mobileApp9,
        fullImage: mobileApp9
    },
    {
        title: '',
        thumbnail: mobileApp9,
        fullImage: mobileApp9
    },
    {
        title: '',
        thumbnail: mobileApp10,
        fullImage: mobileApp10
    }
]
export const ecommerceProjects = [
    {
        title: '',
        thumbnail: ecommerce1,
        fullImage: ecommerceFull1
    },
    {
        title: '',
        thumbnail: ecommerce2,
        fullImage: ecommerceFull2
    },
    {
        title: '',
        thumbnail: ecommerce3,
        fullImage: ecommerceFull3
    },
    {
        title: '',
        thumbnail: ecommerce4,
        fullImage: ecommerceFull4
    },
    {
        title: '',
        thumbnail: ecommerce5,
        fullImage: ecommerceFull5
    },
    {
        title: '',
        thumbnail: ecommerce6,
        fullImage: ecommerceFull6
    }
]
export const shopifyProjects = [
    {
        title: '',
        thumbnail: shopify1,
        fullImage: shopifyFull1
    },
    {
        title: '',
        thumbnail: shopify2,
        fullImage: shopifyFull2
    },
    {
        title: '',
        thumbnail: shopify3,
        fullImage: shopifyFull3
    },
    {
        title: '',
        thumbnail: shopify4,
        fullImage: shopifyFull4
    },
    {
        title: '',
        thumbnail: shopify5,
        fullImage: shopifyFull5
    },
    {
        title: '',
        thumbnail: shopify6,
        fullImage: shopifyFull6
    },
    {
        title: '',
        thumbnail: shopify7,
        fullImage: shopifyFull7
    },
    {
        title: '',
        thumbnail: shopify8,
        fullImage: shopifyFull8
    },
    {
        title: '',
        thumbnail: shopify9,
        fullImage: shopifyFull9
    }
]
export const wordpressProjects = [
    {
        title: '',
        thumbnail: wordpress1,
        fullImage: wordpressFull1
    },
    {
        title: '',
        thumbnail: wordpress2,
        fullImage: wordpressFull2
    },
    {
        title: '',
        thumbnail: wordpress3,
        fullImage: wordpressFull3
    },
    {
        title: '',
        thumbnail: wordpress4,
        fullImage: wordpressFull4
    },
    {
        title: '',
        thumbnail: wordpress5,
        fullImage: wordpressFull5
    },
    {
        title: '',
        thumbnail: wordpress6,
        fullImage: wordpressFull6
    },
    {
        title: '',
        thumbnail: wordpress7,
        fullImage: wordpressFull7
    },
    {
        title: '',
        thumbnail: wordpress8,
        fullImage: wordpressFull8
    },
    {
        title: '',
        thumbnail: wordpress9,
        fullImage: wordpressFull9
    },
    {
        title: '',
        thumbnail: wordpress10,
        fullImage: wordpressFull10
    },
    {
        title: '',
        thumbnail: wordpress11,
        fullImage: wordpressFull11
    },
    {
        title: '',
        thumbnail: wordpress12,
        fullImage: wordpressFull12
    }
]

export const projectsCate = [
    {
        key: '0',
        label: 'Custom Website',
        title: 'Custom Website',
        projects: projects
    },
    {
        key: '1',
        label: 'Ecommerce',
        title: 'Ecommerce Solution',
        projects: ecommerceProjects
    },
    {
        key: '2',
        label: 'Wordpress',
        title: 'WordPress Website',
        projects: wordpressProjects
    },
    {
        key: '3',
        label: 'Mobile App',
        title: 'Mobile Application Development',
        projects: mobileApplicationProjects
    },
    {
        key: '4',
        label: 'Shopify',
        title: 'Shopify Website',
        projects: shopifyProjects
    }
]